var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "950" },
      model: {
        value: _vm.dialog2,
        callback: function($$v) {
          _vm.dialog2 = $$v
        },
        expression: "dialog2"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("edit")]),
                  _vm._v("\n        Modificar registro\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Fecha de ejecución",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  type: "date",
                                  outline: "",
                                  disabled: "",
                                  success: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.obtenerGestion()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_ejecucion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_ejecucion", $$v)
                                  },
                                  expression: "form.fecha_ejecucion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Gestión",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  success: "",
                                  disabled: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.gestion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "gestion", $$v)
                                  },
                                  expression: "form.gestion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.lista_cargos,
                                  "item-text": "cargo",
                                  "item-value": "id_cargo",
                                  label: "Seleccione el cargo",
                                  outline: "",
                                  success: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.cargarHaber()
                                  }
                                },
                                model: {
                                  value: _vm.form.id_cargo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_cargo", $$v)
                                  },
                                  expression: "form.id_cargo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Porcentaje de incremento (%)",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  type: "number",
                                  outline: "",
                                  success: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.cargarHaber()
                                  }
                                },
                                model: {
                                  value: _vm.form.porcentaje,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "porcentaje", $$v)
                                  },
                                  expression: "form.porcentaje"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _vm.form.id_cargo
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: "Haber básico actual",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      success: "",
                                      clearable: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.form.haber_basico_actual,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "haber_basico_actual",
                                          $$v
                                        )
                                      },
                                      expression: "form.haber_basico_actual"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _vm.form.id_cargo && _vm.form.haber_basico_actual
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: "Haber básico incrementado",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      success: "",
                                      clearable: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.form.haber_basico_incrementado,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "haber_basico_incrementado",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.haber_basico_incrementado"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      },
                      on: {
                        click: function($event) {
                          return _vm.modificarIncremento()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-305bc20c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-305bc20c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/incremento_salarial/dialogs/ModificarIncrementoDetalle.vue
// module id = null
// module chunks = 